import { render, staticRenderFns } from "./TeyaPostavke.vue?vue&type=template&id=448279eb&scoped=true"
import script from "./TeyaPostavke.vue?vue&type=script&lang=js"
export * from "./TeyaPostavke.vue?vue&type=script&lang=js"
import style0 from "./TeyaPostavke.vue?vue&type=style&index=0&id=448279eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448279eb",
  null
  
)

export default component.exports